import { ApplicationConfig } from '@angular/core';

import { APP_INITIALIZERS } from '@zeusm/shared/core/init';

import { CUSTOM_PROVIDERS_CONFIG, ROUTING_CONFIG, SERVICES_PROVIDES } from './app.providers';

export const appConfig: ApplicationConfig = {
  providers: [APP_INITIALIZERS, ...SERVICES_PROVIDES, ...CUSTOM_PROVIDERS_CONFIG, ...ROUTING_CONFIG],
};
